import React from "react";
import { PromptModal } from "@/components/Common/PromptModal";
import { ConfirmationModalProps, useConfirmationModal } from "@/hooks/useConfirmationModal";

export const useDeleteWindowConfirmationModal = () => {
    const { ConfirmationModal, confirm, withConfirmation } = useConfirmationModal(DeleteWindowConfirmationModal);

    return {
        DeleteWindowConfirmationModal: ConfirmationModal,
        confirmDeleteWindow: confirm,
        withDeleteWindowConfirmation: withConfirmation,
    };
};

type DeleteWindowConfirmationModalProps = ConfirmationModalProps;

const DeleteWindowConfirmationModal = ({ isOpen, onClose, onContinue }: DeleteWindowConfirmationModalProps) => {
    return (
        <PromptModal
            title="Warning: Applies to Past Purchases"
            isOpen={isOpen}
            onConfirm={onContinue}
            onClose={onClose}
        >
            <span>
                This change will also apply to all past purchases of this experience. Would you like to continue?
            </span>
        </PromptModal>
    );
};
